const Collapse = globalThis.unlk?.Collapse;

document.addEventListener('DOMContentLoaded', () => {
  const desktopNav = document.querySelector('#toc-nav');
  const mobileNav = document.querySelector('#toc-nav-mobile');
  const navs = [desktopNav, mobileNav].filter(Boolean);

  if (!navs.length) return;

  const desktopProgressLine = desktopNav?.querySelector('.progress-line') || null;

  const canonicalNav = desktopNav || mobileNav;
  const canonicalLinks = Array.from(canonicalNav.querySelectorAll('.nav-link[href^="#"]'));
  if (!canonicalLinks.length) return;

  const article = document.querySelector('.post-article') || document.querySelector('.entry-content');
  if (!article) return;

  const getOffset = () => {
    const candidates = ['header', '#blog-nav', '.blog-nav', '.wpadminbar'];
    let h = 0;

    for (const sel of candidates) {
      for (const el of document.querySelectorAll(sel)) {
        const pos = getComputedStyle(el).position;
        if (pos !== 'sticky' && pos !== 'fixed') continue;

        const rect = el.getBoundingClientRect();
        if (rect.bottom > 0 && rect.top <= 1) h += Math.round(rect.height);
      }
    }

    return h + 16;
  };

  let offset = getOffset();
  document.documentElement.style.setProperty('--toc-offset', `${offset}px`);

  const getTargets = () =>
    canonicalLinks
      .map((link) => {
        const href = link.getAttribute('href') || '';
        const id = href.startsWith('#') ? href.slice(1) : '';
        const el = id ? document.getElementById(id) : null;
        return { id, el };
      })
      .filter((x) => x.el);

  let targets = getTargets();

  const isAtArticleBottom = () => {
    const rect = article.getBoundingClientRect();
    return rect.bottom <= offset + 8;
  };

  const clearAllStates = () => {
    for (const nav of navs) {
      const links = Array.from(nav.querySelectorAll('.nav-link[href^="#"]'));
      for (const link of links) {
        link.classList.remove('active', 'is-past');
        link.removeAttribute('aria-current');
      }
    }

    if (desktopProgressLine) desktopProgressLine.style.transform = 'scaleY(0)';
  };

  const setStateByIndex = (idx) => {
    for (const nav of navs) {
      const links = Array.from(nav.querySelectorAll('.nav-link[href^="#"]'));
      for (const [i, link] of links.entries()) {
        link.classList.toggle('active', i === idx);
        link.classList.toggle('is-past', i < idx);
        if (i === idx) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      }
    }

    if (desktopProgressLine) {
      desktopProgressLine.style.transform = `scaleY(${(idx + 1) / canonicalLinks.length})`;
    }
  };

  const computeActiveIndex = () => {
    if (!targets.length) return -1;

    if (isAtArticleBottom()) return targets.length - 1;

    // Activate a little before it reaches the top line so it feels right
    const ACTIVATION_LEAD = 60;
    const line = offset + ACTIVATION_LEAD;

    const firstTop = targets[0].el.getBoundingClientRect().top;
    if (firstTop > line) return -1;

    let active = 0;
    for (const [i, target] of targets.entries()) {
      const {top} = target.el.getBoundingClientRect();
      if (top <= line) active = i;
      else break;
    }

    return active;
  };

  let raf = null;
  const sync = () => {
    offset = getOffset();
    document.documentElement.style.setProperty('--toc-offset', `${offset}px`);

    targets = getTargets();

    const idx = computeActiveIndex();
    if (idx === -1) {
      clearAllStates();
      return;
    }

    setStateByIndex(idx);
  };

  window.addEventListener(
    'scroll',
    () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = null;
        sync();
      });
    },
    { passive: true }
  );

  const handleNavClick = (e) => {
    const a = e.target.closest('.nav-link[href^="#"]');
    if (!a) return;

    const id = (a.getAttribute('href') || '').slice(1);
    const el = id ? document.getElementById(id) : null;
    if (!el) return;

    e.preventDefault();
    // eslint-disable-next-line no-restricted-globals
    history.pushState(null, '', `#${id}`);

    offset = getOffset();
    document.documentElement.style.setProperty('--toc-offset', `${offset}px`);

    const top = window.scrollY + el.getBoundingClientRect().top - offset;
    window.scrollTo({ top, behavior: 'smooth' });

    // Close the mobile collapse (if open)
    const collapseEl = document.querySelector('#toc-mobile-collapse');
    if (collapseEl && collapseEl.classList.contains('show')) {
      const instance = Collapse.getOrCreateInstance(collapseEl);
      instance.hide();
    }

    setTimeout(sync, 120);
    setTimeout(sync, 300);
    setTimeout(sync, 600);
  };

  if (desktopNav) desktopNav.addEventListener('click', handleNavClick);
  if (mobileNav) mobileNav.addEventListener('click', handleNavClick);

  window.addEventListener('load', () => sync());
  window.addEventListener('resize', () => {
    clearTimeout(globalThis.__tocResizeTimer);
    globalThis.__tocResizeTimer = setTimeout(sync, 150);
  });

  sync();
});
